// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NYN9","col":"styles_col__2I9nr","actions":"styles_actions__61s5Z","conflict":"styles_conflict__-QcmC"};